/** @param {{ is_private_booking?: boolean, channel?: string, booking_source?: string, booking?: { booking_source?: string, channel?: string } }} row */
export const isPrivateBooking = (row) =>
  row?.channel === 'external' ||
  row?.is_private_booking === true ||
  row?.booking_source === 'vendor_manual' ||
  row?.booking?.booking_source === 'vendor_manual' ||
  row?.booking?.channel === 'external';

/** @deprecated Prefer CHANNEL_LABELS.external / ChannelBadge */
export const PRIVATE_BOOKING_LABEL = 'External';

export const PRIVATE_PAYOUT_EXCLUDED_NOTE = 'Not included in platform payouts';

/** Vendor channel: marketplace (internal) vs off-platform (external). */
export const CHANNEL = {
  INTERNAL: 'internal',
  EXTERNAL: 'external',
};

export const CHANNEL_LABELS = {
  internal: 'Internal',
  external: 'External',
};

/**
 * Resolve channel from a booking / payment row.
 * Prefers API `channel` when present.
 */
export const getBookingChannel = (row) => {
  if (row?.channel === CHANNEL.INTERNAL || row?.channel === CHANNEL.EXTERNAL) {
    return row.channel;
  }
  if (row?.booking?.channel === CHANNEL.INTERNAL || row?.booking?.channel === CHANNEL.EXTERNAL) {
    return row.booking.channel;
  }
  return isPrivateBooking(row) ? CHANNEL.EXTERNAL : CHANNEL.INTERNAL;
};

/**
 * Invoice is external when billed to a guest contact (no platform client).
 * Prefers API `channel` / `is_external` when present.
 */
export const isExternalInvoice = (inv) => {
  if (!inv) return false;
  if (inv.channel === CHANNEL.EXTERNAL || inv.is_external === true) return true;
  if (inv.channel === CHANNEL.INTERNAL || inv.is_external === false) return false;
  if (inv.recipient_type === 'guest' || inv.recipient_type === 'external') return true;
  if (inv.client_id) return false;
  return Boolean(inv.guest_name || inv.guest_email || inv.is_guest);
};

export const getInvoiceChannel = (inv) => {
  if (inv?.channel === CHANNEL.INTERNAL || inv?.channel === CHANNEL.EXTERNAL) {
    return inv.channel;
  }
  return isExternalInvoice(inv) ? CHANNEL.EXTERNAL : CHANNEL.INTERNAL;
};
